<template>
  <el-button :size="size" @click="onClick" :type="type" plain :disabled="disabled">
    <slot></slot>
  </el-button>
</template>

<script>
export default {
  name: "OAButton",
  props: {
    type: {
      default: "primary"
    },
    disabled: {
      default: null
    },
    size: {
      default: "medium"
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/OAButton/OAButton.vue